import { useTranslation } from "react-i18next";
import { Dialog, List, RadioButton } from "react-native-paper";
import DialogWrapper from "../../DialogWrapper";
import {
	THEME_PREFERENCES,
	THEME_PREFERENCE_ICONS,
	type ThemePreference,
	isThemePreference,
} from "./theme-preference";

export type ThemeDialogProps = {
	visible: boolean;
	preference: ThemePreference;
	onSelect: (preference: ThemePreference) => void;
	onDismiss: () => void;
};

export const ThemeDialog = ({
	visible,
	preference,
	onSelect,
	onDismiss,
}: ThemeDialogProps) => {
	const { t } = useTranslation();

	return (
		<DialogWrapper
			visible={visible}
			handleClose={onDismiss}
			width="90%"
			maxWidth={400}
		>
			<Dialog.Icon icon="theme-light-dark" />
			<Dialog.Title style={{ textAlign: "center" }}>
				{t("account.selectTheme")}
			</Dialog.Title>
			<Dialog.Content style={{ paddingHorizontal: 0 }}>
				<RadioButton.Group
					value={preference}
					onValueChange={(value) => {
						if (!isThemePreference(value)) {
							return;
						}

						onSelect(value);
						onDismiss();
					}}
				>
					{THEME_PREFERENCES.map((value) => (
						<List.Item
							key={value}
							title={t(`account.themeOptions.${value}`)}
							left={(props) => (
								<List.Icon {...props} icon={THEME_PREFERENCE_ICONS[value]} />
							)}
							right={() => <RadioButton value={value} />}
							onPress={() => {
								onSelect(value);
								onDismiss();
							}}
						/>
					))}
				</RadioButton.Group>
			</Dialog.Content>
		</DialogWrapper>
	);
};

export default ThemeDialog;
